import React, { Component } from 'react';
import { useHistory } from 'react-router-dom';
import {Navbar, Nav, NavDropdown} from 'react-bootstrap';


const NavBar = () => {

    const history = useHistory();

    return(

        <Navbar style={{ backgroundColor:'black'}}>
            <Navbar.Brand style={{fontSize:"3.5vh", width:"20vw"}}>
                <div className="row">
                    <div className="col-6">
                        <span style={{color:'white',fontSize:"4vh"}}>CS Tech</span>
                    </div>
                </div>
            </Navbar.Brand>
            <Navbar.Toggle />
            <Navbar.Collapse className="justify-content-end">
                <div className="row" style={{paddingRight:"2vw"}}>
                    <div className="col-4" >
                        <img style={{width:"50vw"}}src="https://cloud-1de12d.becdn.net/media/iW=261&iH=56&oX=0&oY=0&cW=260&cH=56/126163781c08429997f2007c128dc609/1751.png"></img>
                    </div>
                </div>
            </Navbar.Collapse>
        </Navbar>
    )
    
}
 
export default NavBar;
